import { Action, Reducer, ActionCreator, combineReducers } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { batch } from 'react-redux';
import { DataManager, Query } from '@syncfusion/ej2-data';

import { RootState } from '..';
import { IWebinarDetailsState } from '../../interfaces/states/IWebinarDetailsState';
import { IWebinar } from '../../common/model/webinar.model';
import { IODataService, } from '../../services';
import * as webinarUtils from '../../utils/webinar.utils';

export enum Type {
  SET_WEBINARS = '@@webinarDetails/SET_WEBINARS'
}

const initialState: IWebinarDetailsState = {
  webinars: []
};

// Actions

export type Actions = SetWebinarsAction;

export interface SetWebinarsAction extends Action<Type.SET_WEBINARS> {
  webinars: IWebinar[];
}

export const setWebinars: ActionCreator<SetWebinarsAction> = (webinarsLocal: IWebinar[]) => ({
  type: Type.SET_WEBINARS,
  webinars: webinarsLocal
});

export const fetchWebinars: ActionCreator<ThunkAction<void, RootState, unknown, Actions>> = (
  oDataService: IODataService,
  webinarsDataManager: DataManager,
  webinarsQuery: Query
) => (
    async (dispatch) => {
      let query = webinarsQuery.page(1, 100);
      query = query.sortByDesc('date');

      const webinarsResponse = await oDataService.executeQueryWithCount<IWebinar>(webinarsDataManager, query);
      const webinarsLocal = webinarsResponse.result.map((webinar) => webinarUtils.initDates(webinar));
      batch(() => {
        dispatch(setWebinars(webinarsLocal));
      });
    }
);

// Reducers

const webinars: Reducer<IWebinar[]> = (state = initialState.webinars, action) => {
  switch (action.type) {
    case Type.SET_WEBINARS:
      return (action as SetWebinarsAction).webinars;
    default:
      return state;
  }
};

export const webinarDetailsStore = combineReducers({
  webinars
});
